import React from "react";
import { Form, Card } from "antd";

import {
  EditFormProps,
  WidgetTitleFormField,
  SignalSelectorList,
} from "../../WidgetEditForm";
import { Config } from "./BooleanWidget";

function sanitizeInputs(c: Config): Config {
  return {
    title: c.title,
    signals: c.signals.filter((s) => !!s),
    type: "boolean",
  };
}

const EditForm: React.FC<EditFormProps> = (props) => {
  return (
    <div className="boolean-widget-edit-form">
      <Form
        onFinish={(values) => props.onFinish(sanitizeInputs(values as Config))}
        layout="vertical"
        form={props.form}
        initialValues={props.config}
      >
        <Card title="Boolean Widget Settings">
          <WidgetTitleFormField />
          <SignalSelectorList max={10} signals={props.template.signals} rules= {[]} isColor={"boolean"} />
        </Card>
      </Form>
    </div>
  );
};

export default EditForm;
